<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { storeToRefs } from 'pinia';
  import { TabsMenu } from '@/shared/ui';
  import { useFormPermissionsSelectionStore } from '../../model/form-permissions-selection.store';
  import PermissionsConfigureTab from './PermissionsConfigureTab.vue';
  import PermissionsViewTab from './PermissionsViewTab.vue';
  import { usePermissionSubjects } from '../../composables/usePermissionSubjects';

  withDefaults(defineProps<{ locked?: boolean }>(), { locked: false });

  const TABS = [
    { id: 'configure', text: 'Configurar' },
    { id: 'view', text: 'Ver permissões' },
  ];

  const activeTab = ref('configure');
  const { addMode } = storeToRefs(useFormPermissionsSelectionStore());

  function selectTab(tabId: string) {
    if (addMode.value) return;
    activeTab.value = tabId;
  }

  const {
    positions,
    functionalActivities,
    isLoadingPositions,
    isLoadingFunctionalActivities,
    hasPositionsError,
    hasFunctionalActivitiesError,
    load,
  } = usePermissionSubjects();

  onMounted(load);
</script>

<template>
  <aside
    class="flex h-full w-[405px] shrink-0 flex-col border-l border-gray-02 bg-white-02"
    data-testid="form-builder-permissions-sidebar"
  >
    <div
      class="flex items-center border-b border-gray-02 px-4 pt-6 pb-4"
      :inert="addMode"
      :class="{ 'opacity-60': addMode }"
    >
      <TabsMenu
        :options="TABS"
        :selected-option="activeTab"
        visual-variant="neutral"
        @option-selected="selectTab"
      />
    </div>

    <div class="flex min-h-0 flex-1 flex-col">
      <PermissionsConfigureTab
        v-show="activeTab === 'configure'"
        :locked="locked"
        :positions="positions"
        :functional-activities="functionalActivities"
        :is-loading-positions="isLoadingPositions"
        :is-loading-functional-activities="isLoadingFunctionalActivities"
        :has-positions-error="hasPositionsError"
        :has-functional-activities-error="hasFunctionalActivitiesError"
      />
      <PermissionsViewTab
        v-show="activeTab === 'view'"
        :positions="positions"
        :functional-activities="functionalActivities"
        :is-loading-positions="isLoadingPositions"
        :is-loading-functional-activities="isLoadingFunctionalActivities"
        :has-positions-error="hasPositionsError"
        :has-functional-activities-error="hasFunctionalActivitiesError"
      />
    </div>
  </aside>
</template>
